import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the search bar and filters to find transactions by <strong>access code</strong>, <strong>student name</strong>, or other criteria." id="use_the_search_bar_and_filters_to_find_t.dcc13888" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Searching Transactions" id="searching_transactions.bfc677d9" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click a transaction row to view its details. Use the <strong>tabs</strong> to switch between access code info, activity history, assigned students, and reports." id="click_a_transaction_row_to_view_its_deta.b84c6e1d" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Transaction Details" id="transaction_details.af38246d" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>Assign Content</strong> feature to link classroom content to an access code, making it available to students who redeem the code." id="use_the_assign_content_feature_to_link_c.1e2453ed" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Assigning Content" id="assigning_content.52ba01bb" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="View and manage <strong>license restrictions</strong> to control which products and features are accessible through each access code." id="view_and_manage_license_restrictions_to.383d853b" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="License Restrictions" id="license_restrictions.11993c5c" />
        }
    ],
    title: <FormattedMessage defaultMessage="Access Codes" id="access_codes.3114ae04" />
};
